import { render, staticRenderFns } from "./SierraWidget.vue?vue&type=template&id=d615a2c6&lang=pug"
import script from "./SierraWidget.vue?vue&type=script&lang=js"
export * from "./SierraWidget.vue?vue&type=script&lang=js"
import style0 from "./SierraWidget.vue?vue&type=style&index=0&id=d615a2c6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports